module.exports = __webpack_public_path__ + "img/btn-znqd.570dbc91.png";